define('components/tooltip/collections/tooltip',[
    "components/tooltip/models/tooltip"
], function(TooltipModelClass) {
    "use strict";

    return Backbone.Collection.extend({
        "model": TooltipModelClass

    });
});

